import _classCallCheck from "/app/node_modules/.pnpm/@babel+runtime@7.0.0/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/app/node_modules/.pnpm/@babel+runtime@7.0.0/node_modules/@babel/runtime/helpers/esm/createClass";
var DeferredRegistry = /*#__PURE__*/function () {
  function DeferredRegistry() {
    _classCallCheck(this, DeferredRegistry);
    this.registry = new Map();
  }
  _createClass(DeferredRegistry, [{
    key: "register",
    value: function register(id, resolve, reject) {
      this.registry.set(id, {
        resolve: resolve,
        reject: reject
      });
    }
  }, {
    key: "complete",
    value: function complete(_ref) {
      var id = _ref.id,
        error = _ref.error,
        result = _ref.result;
      if (!this.registry.has(id)) return;
      var _this$registry$get = this.registry.get(id),
        resolve = _this$registry$get.resolve,
        reject = _this$registry$get.reject;
      if (error) {
        reject(error);
      } else {
        resolve(result);
      }
    }
  }]);
  return DeferredRegistry;
}();
export { DeferredRegistry as default };